export default __webpack_public_path__ + "static/piscina-termica-21197fcad3e993e7431cacd2cf66bc4f.jpg";